import { Chip } from "../../../../components/common/chip";
import type { ChipVariant } from "../../../../components/common/chip/chip";

type ClaimStatus = "NEW" | "ACKNOWLEDGED" | "INVESTIGATING" | "MEDIATING" | "ESCALATED" | "RESOLVED" | "REJECTED";

const STATUS_VARIANT: Record<ClaimStatus, ChipVariant> = {
  NEW: "inReview",
  ACKNOWLEDGED: "underReview",
  INVESTIGATING: "secondary",
  MEDIATING: "tertiary",
  ESCALATED: "expired",
  RESOLVED: "approved",
  REJECTED: "rejected",
};

const STATUS_LABEL: Record<ClaimStatus, string> = {
  NEW: "New",
  ACKNOWLEDGED: "Acknowledged",
  INVESTIGATING: "Investigating",
  MEDIATING: "Mediating",
  ESCALATED: "Escalated",
  RESOLVED: "Resolved",
  REJECTED: "Rejected",
};

interface ClaimStatusChipProps {
  status: string;
}

export function ClaimStatusChip({ status }: ClaimStatusChipProps) {
  const s = status as ClaimStatus;
  return (
    <Chip variant={STATUS_VARIANT[s] ?? "tertiary"}>
      {STATUS_LABEL[s] ?? status}
    </Chip>
  );
}
